import script from "./UserPermission.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPermission.vue?vue&type=script&setup=true&lang=ts"

import "./UserPermission.vue?vue&type=style&index=0&id=00dcf8fc&lang=css"

const __exports__ = script;

export default __exports__